import { AccountItemEnum } from '../../../../../../../../../modules/mobile/modals/profile';

export default {
  title: 'Konto',
  items: {
    [AccountItemEnum.ManageAccount]: {
      title: 'Konto verwalten',
      description: 'Halten Sie Ihr Konto auf dem neuesten Stand und verwalten Sie Ihre Einstellungen.',
    },
    [AccountItemEnum.PaymentMethods]: {
      title: 'Zahlungsmethoden',
      description: 'Fügen Sie Ihre bevorzugte Zahlungsmethode hinzu, ändern Sie sie oder wählen Sie sie aus.',
    },
    [AccountItemEnum.HelpAndFAQs]: {
      title: 'Hilfe und FAQs',
    },
    [AccountItemEnum.Logout]: {
      title: 'Ausloggen',
    },
    [AccountItemEnum.Language]: {
      title: 'Sprache',
    },
  },
};
